import React from 'react';
import _ from 'lodash';
import { Notification } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';

export type PurchaseErrorNotificationProps = {
  isMobileView?: boolean;
  isError: boolean;
  setPurchaseError: (isError: boolean) => void;
  isViewer?: boolean;
};

function PurchaseErrorNotification({
  isMobileView,
  isError,
  setPurchaseError,
  isViewer,
}: PurchaseErrorNotificationProps) {
  const { t } = useTranslation();

  return isMobileView ? (
    <Notification
      type={isViewer ? 'global' : 'local'}
      theme="error"
      zIndex={5000}
      show={isError}
      autoHideTimeout={5000}
      dataHook="purchase-error"
    >
      <Notification.TextLabel ellipsis={false}>
        {t('marketplace.template-purchase-error')}
      </Notification.TextLabel>
    </Notification>
  ) : (
    <Notification
      type="global"
      theme="error"
      zIndex={5000}
      show={isError}
      autoHideTimeout={5000}
      onClose={() => setPurchaseError(false)}
    >
      <Notification.TextLabel ellipsis={false}>
        {t('marketplace.template-purchase-error')}
      </Notification.TextLabel>
      <Notification.CloseButton />
    </Notification>
  );
}

export default PurchaseErrorNotification;
